module.exports = __webpack_public_path__ + "static/media/017.56cdd200.jpg";